import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { format } from "date-fns";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import type { OrganizationTaskTemplateRow } from "../organizationTaskTemplatesViewConfig";
import { getOrganizationTaskTemplatesTableMeta } from "../organizationTaskTemplatesTableMeta";

export const OrganizationTaskTemplateUpdatedCell = memo(
    function OrganizationTaskTemplateUpdatedCell({
        row,
        table,
    }: CellContext<ViewTableFeatures, OrganizationTaskTemplateRow, string>) {
        const meta = getOrganizationTaskTemplatesTableMeta(table);
        const updatedAt = meta?.templatesById.get(row.original.id)?.updatedAt;

        return (
            <ViewTableCell>
                <span>
                    {updatedAt ? format(updatedAt, "MMM d, yyyy") : "-"}
                </span>
            </ViewTableCell>
        );
    },
);
